import "./Button.scss";

const Button = ({className, content, handleClick}) => {
  return (
    <button className={`btn ${className ? className : ""}`} type="button" onClick={handleClick?handleClick:""}>
      {content}
    </button>
  )
}

export default Button;